import React, { Component, ReactNode } from 'react';
import { RotateLeftIcon } from '@inter-ikea-kompis/icons';
import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { WriteDirection, DeviceType, Platform } from 'sofa-reborn-react';
import { localeService } from '../../services';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { StyledRotationIcon } from './RotationIconStyle';
import { KompisText, KompisIcon } from '@inter-ikea-kompis/react-components';

type Props = {
	top: string;
	left: string;
	writeDirection: WriteDirection;
	deviceType: DeviceType;
	platform: Platform;
	showRotationIcon: boolean;
};

/**
 * React component.
 *
 */
export default class RotationIcon extends Component<Props> {
	/**
	 * React render method.
	 *
	 * @returns React node.
	 */
	public render(): ReactNode {
		const { props } = this;
		return (
			<StyledRotationIcon
				top={props.top}
				left={props.left}
				deviceType={props.deviceType}
				showRotationIcon={props.showRotationIcon}
			>
				<KompisIcon
					theme={SkapaTheme}
					icon={RotateLeftIcon || ''}
					// @ts-expect-error Kompis elemenets support style but it isn't exposed
					style={{
						paddingRight: props.writeDirection === 'ltr' ? '8px' : '0',
						paddingLeft: props.writeDirection === 'rtl' ? '8px' : '0',
					}}
				/>
				<KompisText theme={SkapaTheme} type={ThemeFontStyleTypeEnum.bodyLarge}>
					{localeService.getTranslation('rotationText')}
				</KompisText>
			</StyledRotationIcon>
		);
	}
}
